import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { User } from '@zep/types';

import { buildFormData } from '../../utils';
import { UseZepApiMutationOptions } from '../types';
import { useZepApiClient } from '../ZepApiProvider';

import { QUERY_KEY_ME } from './query';
import { PlayerResponse } from './types';

/**
 * 내 정보 조회 API Hook
 * @version V2
 * @returns Mutation States
 */
/**
 * @deprecated API type 마이그레이션이 필요합니다. README의 API Type Safety 가이드를 참고하세요: docs/api-type-safety.md
 */
export function useGetMe(options?: UseZepApiMutationOptions<User>) {
  const client = useZepApiClient();
  return useMutation(
    async () => {
      const { data } = await client.get(`/v2/me`);
      return data.player;
    },
    {
      ...options,
    },
  );
}

/**
 * 내 정보 수정 Mutation Hook
 * @version V1
 * @returns Mutation States
 */
/**
 * @deprecated API type 마이그레이션이 필요합니다. README의 API Type Safety 가이드를 참고하세요: docs/api-type-safety.md
 */
export function useUpdateMe(
  options?: UseZepApiMutationOptions<void, Partial<PlayerResponse>>,
) {
  const client = useZepApiClient();
  const queryClient = useQueryClient();
  return useMutation(
    player => {
      return client.postForm('/me', buildFormData(player));
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        options?.onSuccess?.(data, variables, context);
        queryClient.invalidateQueries(QUERY_KEY_ME);
      },
    },
  );
}

/**
 * @deprecated API type 마이그레이션이 필요합니다. README의 API Type Safety 가이드를 참고하세요: docs/api-type-safety.md
 */
export function useLogout(options?: UseZepApiMutationOptions) {
  const client = useZepApiClient();
  const queryClient = useQueryClient();
  return useMutation(
    async () => {
      await client.postForm('/v2/me/logout');
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        options?.onSuccess?.(data, variables, context);
        queryClient.removeQueries(QUERY_KEY_ME);
      },
    },
  );
}

/**
 * @deprecated API type 마이그레이션이 필요합니다. README의 API Type Safety 가이드를 참고하세요: docs/api-type-safety.md
 */
export function useWithdraw(
  options?: UseMutationOptions<{
    status: number;
    statusKey: string;
    data: null;
  }>,
) {
  const client = useZepApiClient();
  return useMutation(async () => {
    const { data } = await client.post('/v2/me/delete');
    return data;
  }, options);
}
